/**
 * Validation utilities for StructureNote
 * Handles investment amount validation
 * Extracted from original lines 179-196
 */

/**
 * Validate investment/subscription amount format and constraints
 * Original logic from validateInvestorSubscribeAmount function (lines 179-196)
 *
 * @param inputValue - Value to validate
 * @param maxAmount - Maximum allowed amount (amountAvailableForInvestment)
 * @returns true if valid, false if invalid
 */
export const validateInvestmentAmount = (inputValue: string, maxAmount: string): boolean => {
  // Check if the input matches the money format: positive number with up to two decimal places
  const isValidFormat = /^\d*\.?\d{0,2}$/.test(inputValue);

  if (!isValidFormat) {
    return false;
  }

  const inputNumber = parseFloat(inputValue);
  const amountAvailable = parseFloat(maxAmount || "0");

  // Check if input exceeds available amount
  if (inputNumber > amountAvailable) {
    return false;
  }

  return true;
};
